import React from "react";
import { Alert } from "react-bootstrap";
import { AdvertCard } from "../AdvertCard";
import { useFetch } from "lib/useFetch";
import { AdvertPreviewLayout } from "./AdvertPreviewLayout";
const currentUrl = window.location.href;

const ADVERT_PREVIEW_URL = currentUrl.includes("advert2")
  ? "/research/japi/content/preview/advert2/"
  : "/research/japi/content/preview/advert/";
const IMAGE_PREVIEW_URL = "/research/japi/content/preview/assets/";

export const AdvertPreview = ({ match }) => {
  const id = match.params.id || null;
  const [advert, , err] = useFetch(ADVERT_PREVIEW_URL + id, null, "GET");
  const parsedAdvert = tryParse(advert);

  if (id === null || err)
    return <Alert variant="warning">Error previewing banner, please contact support or try again later.</Alert>;
  if (!advert || advert.length === 0) return <Alert variant="warning">Could not find banner for id: {id}</Alert>;

  return (
    <AdvertPreviewLayout>
      <AdvertCard {...parsedAdvert} />
    </AdvertPreviewLayout>
  );
};

// correct malformed image URLs from server
function tryParse(advert) {
  if (!advert || advert.length === 0) return null;

  let parsedAdvert = { ...advert };
  try {
    if (advert.img) parsedAdvert.img = IMAGE_PREVIEW_URL + advert.img;
    if (advert.mobileImg) parsedAdvert.mobileImg = IMAGE_PREVIEW_URL + advert.mobileImg;
    if (advert.leftImg) parsedAdvert.leftImg = IMAGE_PREVIEW_URL + advert.leftImg;
    if (advert.rightImg) parsedAdvert.rightImg = IMAGE_PREVIEW_URL + advert.rightImg;
  } catch (err) {
    console.warn("Could not parse preview advert", err);
  }

  return parsedAdvert;
}
